import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { CurveType } from "recharts/types/shape/Curve"

interface AreaProps {
    type?: CurveType
    dataKey: string
    stroke: string
    fill?: string
    fillOpacity?: number
}

const Chart = ({
    data,
    height = 200,
    syncID = undefined,
    XAxisDataKey,
    areas
}: {
    data: any,
    height?: number
    syncID?: string,
    XAxisDataKey: string,
    areas: AreaProps[]
}) => {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <AreaChart
                data={data}
                syncId={syncID}
            >
                <CartesianGrid strokeDasharray="5 5" />
                <XAxis dataKey={XAxisDataKey} />
                <YAxis />
                <Tooltip />
                {areas.map(area => (
                    <Area
                        type={area.type ?? "monotone"}
                        dataKey={area.dataKey}
                        stroke={area.stroke}
                        fill={area.fill ?? area.stroke}
                        fillOpacity={area.fillOpacity ?? 1} />
                ))}
            </AreaChart>
        </ResponsiveContainer>
    )
}

export default Chart;